import { Route, Routes } from 'react-router';

import './App.css';

import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdministrationPage } from './pages/AdministrationPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { DisplayNumbersPage } from './pages/DisplayNumbersPage';
import { EventDetailsPage } from './pages/EventDetailsPage';
import { EventsPage } from './pages/EventsPage';
import { HomePage } from './pages/HomePage';
import { GuestInvitationAcceptancePage } from './pages/GuestInvitationAcceptancePage';
import { LoginPage } from './pages/LoginPage';
import { BookPage } from './pages/BookPage';
import { MyBookingPage } from './pages/MyBookingPage';
import { PlaceholderPage } from './pages/PlaceholderPage';
import { ProfilePage } from './pages/ProfilePage';
import { TelephonesPage } from './pages/TelephonesPage';
import { HelpPage } from './pages/HelpPage';

function App() {
  return (
    <div className="app-shell">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/portal" element={
            <ProtectedRoute><HomePage /></ProtectedRoute>
          } />
          <Route path="/guest/accept" element={<GuestInvitationAcceptancePage />} />
          <Route path="/book" element={
            <ProtectedRoute>
              <BookPage />
            </ProtectedRoute>
          } />
          <Route path="/my-booking" element={
            <ProtectedRoute>
              <MyBookingPage />
            </ProtectedRoute>
          } />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <HelpPage />
              </ProtectedRoute>
            }
          />          
          <Route path="/profile" element={
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          } />
          <Route path="/events" element={
            <ProtectedRoute><EventsPage /></ProtectedRoute>
          } />
          <Route path="/events/:eventId" element={
            <ProtectedRoute><EventDetailsPage /></ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute requireAdministrator><AdministrationPage /></ProtectedRoute>
          } />
          <Route path="/admin/display-numbers" element={
            <ProtectedRoute requireAdministrator><DisplayNumbersPage /></ProtectedRoute>
          } />
          <Route path="/admin/telephones" element={
            <ProtectedRoute requireAdministrator><TelephonesPage /></ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute requireAdministrator><AdminUsersPage /></ProtectedRoute>
          } />
          <Route path="*" element={
            <PlaceholderPage title="Page not found" description="The requested portal page does not exist." />
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
